<template>
    <div class="ft-sa-doc-container">
        <div class="ft-sa-table-header" :style="{ '--grid-columns': gridTemplateColumns }">
            <div v-if="visibleColumns.index">
                <label class="sa-ft-label primary">🔢 #</label>
            </div>
            <div v-if="visibleColumns.articolo">
                <label class="sa-ft-label">📦 Dettaglio Prodotto</label>
            </div>
            <div v-if="visibleColumns.qtaFatt" class="text-center">
                <label class="sa-ft-label">🧾 Q.tà Fatt.</label>
            </div>
            <div v-if="visibleColumns.qta" class="text-center">
                <label class="sa-ft-label">📊 Q.tà</label>
            </div>
            <div v-if="visibleColumns.um" class="text-center">
                <label class="sa-ft-label">📏 Unità Misura</label>
            </div>
            <div v-if="visibleColumns.prezzo" class="text-center">
                <label class="sa-ft-label">💰 Unitario</label>
            </div>
            <div v-if="visibleColumns.sconto" class="text-center">
                <label class="sa-ft-label">🏷️ Sconto</label>
            </div>
            <div v-if="visibleColumns.totale" class="text-center">
                <label class="sa-ft-label">🧮 Totale</label>
            </div>
            <div v-if="visibleColumns.azioni" class="text-right">
                <label class="sa-ft-label">⚙️ Azioni</label>
            </div>
        </div>
        <div class="ft-sa-rows-viewport" v-if="righeDocumento.length > 0">

            <div class="ft-sa-row-card" v-for="(riga, i) in righeDocumento" :key="i">

                <div class="ft-sa-row-content" :style="{ '--grid-columns': gridTemplateColumns }">
                    <div v-if="visibleColumns.index" class="ft-sa-col-index">
                        {{ i + 1 }}
                    </div>
                    <div v-if="visibleColumns.articolo">
                        <span class="ft-sa-col-code ft-sa-badge-um">
                            {{ riga.codiceArticolo }}
                        </span>
                        <div class="ft-sa-col-desc-articolo">
                            {{ riga.descrizione }}
                        </div>
                    </div>
                    <div v-if="visibleColumns.qtaFatt" class="ft-sa-wrapper-col-qty text-center">
                        <div class="ft-sa-badge-um-input text-center" v-if="riga.id">
                            {{ riga.documentoRiferimentoRigaQuantita }}
                        </div>
                        <div class="ft-sa-badge-um-input text-center" v-else>
                            <input type="text" class="sa-ft-input-custom"
                                v-model="riga.documentoRiferimentoRigaQuantita">
                        </div>
                    </div>
                    <div v-if="visibleColumns.qta" class="ft-sa-wrapper-col-qty text-center">
                        <div class="ft-sa-col-qty text-center">
                            {{ riga.quantita }}
                        </div>
                    </div>
                    <div v-if="visibleColumns.um" class="text-center">
                        <div class=" ft-sa-col-um-desc">
                            {{ riga.umDescrizione }}
                        </div>
                        <span class="ft-sa-badge-um">
                            {{ riga.umCodice }}
                        </span>
                    </div>
                    <div v-if="visibleColumns.prezzo" class="ft-sa-col-price text-center">
                        {{ formatCurrency(riga.prezzoUnitario) }}
                    </div>
                    <div v-if="visibleColumns.sconto" class="ft-sa-col-price text-center">

                        {{ formatPercentage(riga.sconto) }} <br />
                        <span style="font-size: 700 !important; font-size: smaller !important;"> {{
                            formatCurrency(calcolaSconto(riga.prezzoUnitario,
                                riga.sconto)) }}</span>
                    </div>
                    <div v-if="visibleColumns.totale" class="ft-sa-col-total text-center">
                        {{ formatCurrency(riga.totaleRiga) }}
                    </div>
                    <div v-if="visibleColumns.azioni" class="ft-sa-action-group">
                        <button class="ft-sa-action-btn ft-sa-btn-edit" title="Modifica"
                            @click="onModificaRigaDocumento({ index: i, item: riga })">

                            <b-icon icon="pencil"></b-icon>
                        </button>
                        <button class="ft-sa-action-btn ft-sa-btn-del" title="Elimina"
                            @click="onEliminaRigaDocumento({ index: i })">
                            <b-icon icon="trash"></b-icon>
                        </button>
                    </div>
                </div>
                <div class="sa-ft-riferimento-doc" v-if="riga.documentoRiferimentoRigaId">
                    <label class="sa-ft-label">{{
                        riga.documentoRiferimentoDescrizione }}</label>
                </div>
                <template v-if="isArticoloGestioneLottiMatricole(riga)">
                    <div class="ft-sa-details-bar" v-if="riga.lottiScadenze && riga.lottiScadenze.length > 0">
                        <div v-for="(lotto, indexLotto) in riga.lottiScadenze" :key="indexLotto"
                            class="ft-sa-lotto-item">
                            <div class="ft-sa-meta-tag">
                                <strong>Lotto</strong>
                                <span>{{ lotto.lottoMatricola }}</span>
                            </div>
                            <div class="ft-sa-meta-tag" v-if="lotto.dataOraScadenza">
                                <strong>Scadenza</strong>
                                <span :class="{ 'text-danger': isExpired(lotto.dataOraScadenza) }">
                                    {{ formatDate(lotto.dataOraScadenza) }}
                                </span>
                            </div>
                            <div class="ft-sa-meta-tag" v-if="lotto.dataOraProduzione">
                                <strong>Produzione</strong>
                                <span>
                                    {{ formatDate(lotto.dataOraProduzione) }}
                                </span>
                            </div>
                            <div class="ft-sa-meta-tag">
                                <strong>Q.tà</strong>
                                <span>{{ lotto.quantita }}</span>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
        <div v-else class="ft-sa-rows-viewport d-flex align-items-center justify-content-center">
            <NoDataComponent ref="cmpNoDataComponent" :fontSize="15" title="Inserisci la prima riga documento"
                subtitle="Nessun articolo presente nel documento" />
        </div>
        <div class="ft-sa-table-footer">
            <button class="ft-sa-add-row-placeholder" @click="onAddRigaDocumento()" :disabled="isBtnPlusDisabled()">
                <b-icon icon="plus-circle-fill" class="mr-2"></b-icon>
                Aggiungi nuova riga documento
            </button>
        </div>
        <div class="ft-sa-list-component-footer">
            <contabilita-documento-riga-documento-modal-component
                ref="cmpContabilitaDocumentoRigaDocumentoModalComponent"
                @modificaRigaDocumento="onModificaRigaDocumentoComponent"
                @addQuantitaRigaDocumentoPresente="onAddQuantitaRigaDocumentoPresente"
                @addRigaDocumento="onAggiungiRigaDocumento" :righeDocumento="righeDocumento" :documento="jsonData" />
        </div>
    </div>
</template>

<script>
import ContabilitaDocumentoRigaDocumentoModalComponent from "./ContabilitaDocumentoRigaDocumentoModalComponent.vue";
import ContabilitaMixin from "../mixins/ContabilitaMixin";
import MagazzinoMixins from "../../magazzino/mixins/MagazzinoMixins";
import UtilityMixin from "../../utility/UtilityMixin";
import NoDataComponent from "../../../template/components/utility/NoDataComponent.vue";

export default {

    name: "RigaDocumentoListComponent",

    inject: [
        "openShowModalLoading",
        "closeShowModalLoading"
    ],

    mixins: [
        ContabilitaMixin,
        MagazzinoMixins,
        UtilityMixin
    ],

    components: {
        ContabilitaDocumentoRigaDocumentoModalComponent,
        NoDataComponent
    },

    props: {
        jsonData: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },

    data() {
        return {
            operazioneMagazzino: 0,
            operazioneContabile: 0,
            currentPage: 1,
            perPage: 100,
            righeDocumento: [],
            rowRigaDocumentoSelezionataIndex: null,
        };
    },

    computed: {
        visibleColumns() {
            return {
                index: true,
                articolo: true,
                qtaFatt:
                    this.operazioneContabile != 0,
                qta: true,
                sconto: true,
                um: true,
                prezzo: true,
                totale: true,
                azioni: true,
            };
        },

        gridTemplateColumns() {
            const cols = [];
            if (this.visibleColumns.index)
                cols.push("40px");
            if (this.visibleColumns.articolo)
                cols.push("1fr");
            if (this.visibleColumns.qtaFatt)
                cols.push("100px");
            if (this.visibleColumns.qta)
                cols.push("100px");
            if (this.visibleColumns.um)
                cols.push("140px");
            if (this.visibleColumns.prezzo)
                cols.push("100px");
            if (this.visibleColumns.sconto)
                cols.push("100px");
            if (this.visibleColumns.totale)
                cols.push("100px");
            if (this.visibleColumns.azioni)
                cols.push("110px");
            return cols.join(" ");
        }
    },

    watch: {

        "jsonData.causaleDocumentoOperazioneMagazzino": function (params) {
            this.operazioneMagazzino = params;
        },
        "jsonData.causaleDocumentoOperazioneContabile": function (params) {
            this.operazioneContabile = params;
        },
    },

    methods: {

        init(jsonData) {
            this.righeDocumento = jsonData.righeDocumento || [];
        },

        isArticoloGestioneLottiMatricole(riga) {
            if (riga.lottiScadenze.length == 1) {
                let lotto = riga.lottiScadenze[0];
                return lotto.dataOraProduzione != lotto.dataOraScadenza;
            }
            return true;
        },
        calcolaSconto(prezzoUnitario, sconto) {
            if (!prezzoUnitario) prezzoUnitario = 0;
            if (!sconto) sconto = 0;

            return (prezzoUnitario * (sconto / 100));
        },
        formatCurrency(value) {
            if (value === null || value === undefined)
                value = 0;
            return value.toLocaleString("it-IT", {
                style: "currency",
                currency: "EUR",
                minimumFractionDigits: 2
            });
        },
        formatPercentage(value) {
            if (value === null || value === undefined)
                value = 0;
            return (value / 100).toLocaleString("it-IT", {
                style: "percent",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        },
        isExpired(date) {
            if (!date)
                return false;
            return new Date(date) < new Date();
        },

        isBtnPlusDisabled() {
            return !this.jsonData.causaleCodice
                || !this.jsonData.magazzinoId;
        },
        onAddRigaDocumento() {
            this.$refs
                .cmpContabilitaDocumentoRigaDocumentoModalComponent
                .onClickAddRiga(this.jsonData);
        },

        onModificaRigaDocumento(row) {
            this.$refs
                .cmpContabilitaDocumentoRigaDocumentoModalComponent
                .onModificaRigaDocumento(row);
        },
        onModificaRigaDocumentoComponent(index, item) {
            this.righeDocumento.splice(index, 1, item);
            this.$emit("update", this.righeDocumento);
        },
        onAggiungiRigaDocumento(riga) {
            this.righeDocumento.push(
                JSON.parse(JSON.stringify(riga))
            );
            this.$emit("update", this.righeDocumento);
        },
        onAddQuantitaRigaDocumentoPresente(riga) {
            if (riga) {
                let result =
                    this.righeDocumento.filter((e) =>
                        e.codiceArticolo == riga.codiceArticolo
                        && e.descrizione == riga.descrizione
                    );
                if (result.length > 0) {
                    let rigaDoc = result[0];
                    rigaDoc.quantita++;
                    this.$emit("update", this.righeDocumento);
                }
            }
        },
        onClickInfoMatricolaLotto(row) {
            this.rowRigaDocumentoSelezionataIndex =
                row.index;
        },
        onEliminaRigaDocumento(row) {
            this.$bvModal
                .msgBoxConfirm(
                    "Sei sicuro di eliminare questa riga?",
                    {
                        title: "Eliminazione Riga Documento",
                        buttonSize: "sm",
                        okTitle: "SI",
                        cancelTitle: "NO",
                        okVariant: "danger",
                        cancelVariant: "secondary",
                        centered: true,
                    }
                )
                .then((value) => {
                    if (value) {
                        this.righeDocumento.splice(
                            row.index,
                            1
                        );
                        this.$emit(
                            "update",
                            this.righeDocumento
                        );
                    }
                });
        }
    },
};
</script>

<style scoped>
.ft-sa-doc-container {
    font-family: 'Inter', -apple-system, sans-serif;
    background: white;
    padding: 26px;
    padding-top: 10px !important;
    color: var(--text-main);
    margin: 0 auto;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    width: 100% !important;
}

/*
|--------------------------------------------------------------------------
| GRID SHARED
|--------------------------------------------------------------------------
*/

.ft-sa-table-header,
.ft-sa-row-content {
    display: grid;
    grid-template-columns: var(--grid-columns);
    align-items: center;
}

/*
|--------------------------------------------------------------------------
| HEADER
|--------------------------------------------------------------------------
*/

.ft-sa-table-header {
    padding: 12px 30px;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    color: var(--primary);
    flex-shrink: 0;
    background: #f8fafc;
    border-bottom: 1px solid var(--border-color);
    border-radius: 12px;
    position: sticky;
    top: 0;
    z-index: 10;
}

.sa-ft-riferimento-doc {
    display: flex;
    justify-content: center;
    padding: 3px;
}

/*
|--------------------------------------------------------------------------
| VIEWPORT
|--------------------------------------------------------------------------
*/

.ft-sa-rows-viewport {
    flex-grow: 1;
    overflow-y: auto;
    padding: 10px 5px;
    margin-bottom: 10px;
}

.ft-sa-rows-viewport::-webkit-scrollbar {
    width: 6px;
}

.ft-sa-rows-viewport::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 10px;
}

/*
|--------------------------------------------------------------------------
| ROW
|--------------------------------------------------------------------------
*/

.ft-sa-row-card {
    background: white;
    border-radius: 12px;
    margin-bottom: 12px;
    transition: all 0.25s ease;
    border: 1px solid #edf2f7;
    position: relative;
    overflow: hidden;
    border-left: 4px solid var(--bg-sidebar-item);
}

.ft-sa-row-card:hover {
    transform: translateY(-2px);
    border-color: var(--primary);
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
}

.ft-sa-row-content {
    padding: 10px 16px;
}

/*
|--------------------------------------------------------------------------
| CELLS
|--------------------------------------------------------------------------
*/

.ft-sa-col-index {
    font-weight: 700;
    color: var(--text-muted);
    opacity: 0.5;
}

.ft-sa-col-code {
    font-size: 10px;
    color: var(--primary);
    background: rgba(var(--primary-rgb), 0.1);
    padding: 2px 8px;
    border-radius: 6px;
    display: inline-block;
    margin-bottom: 4px;
    font-weight: 600;
}

.ft-sa-col-desc-articolo {
    font-weight: 700;
    font-size: 13px;
    color: #1a202c;
}

.ft-sa-wrapper-col-qty {
    display: flex;
    justify-content: center;
}

.ft-sa-col-qty {
    background: #f1f5f9;
    border: 1px solid #cbd5e1;
    border-radius: 8px;
    color: #475569;
    padding: 4px;
    font-weight: 700;
    text-align: center;
    width: 60px;
}

.ft-sa-col-um-desc {
    font-size: 11px;
    font-weight: 600;
    display: block;
}

.ft-sa-col-price {
    font-variant-numeric: tabular-nums;
    font-weight: 500;
    text-align: right;
    color: #64748b;
}

.ft-sa-col-total {
    font-variant-numeric: tabular-nums;
    font-weight: 700;
    text-align: right;
    font-size: 15px;
    color: #0f172a;
}

/*
|--------------------------------------------------------------------------
| LOTTI
|--------------------------------------------------------------------------
*/

.ft-sa-details-bar {
    background: #f8fafc;
    padding: 10px 20px;
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    font-size: 11px;
    justify-content: left;
    border-top: 1px dashed #e2e8f0;
    background-color: #64748b07;
}

.ft-sa-lotto-item {
    display: flex;
    gap: 8px;
    align-items: left;
    border: 2px dotted #334155;
    border-radius: 50px;
    padding: 3px 5px;
}

.ft-sa-meta-tag {
    display: flex;
    align-items: center;
    gap: 5px;
    color: #64748b;
}

.ft-sa-meta-tag strong {
    color: #334155;
    text-transform: uppercase;
    font-size: 9px;
}

/*
|--------------------------------------------------------------------------
| ACTIONS
|--------------------------------------------------------------------------
*/

.ft-sa-action-group {
    display: flex;
    gap: 6px;
    justify-content: flex-end;
}

.ft-sa-action-btn {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    background: white;
    cursor: pointer;
    transition: 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
}

.ft-sa-btn-info:hover {
    background: #e0f2fe;
    color: #0369a1;
    border-color: #7dd3fc;
}

.ft-sa-btn-edit:hover {
    background: #f0fdf4;
    color: #15803d;
    border-color: #86efac;
}

.ft-sa-btn-del:hover {
    background: #fef2f2;
    color: #b91c1c;
    border-color: #fecaca;
}

/*
|--------------------------------------------------------------------------
| FOOTER
|--------------------------------------------------------------------------
*/

.ft-sa-table-footer {
    padding-top: 10px;
    display: flex;
    justify-content: center;
}

.ft-sa-add-row-placeholder {
    border: 2px dashed #cbd5e1;
    border-radius: 12px;
    padding: 12px;
    margin-bottom: 20px;
    text-align: center;
    color: #64748b;
    cursor: pointer;
    transition: all 0.2s;
    background: #f8fafc;
    width: 100%;
    max-width: 400px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
}

.ft-sa-add-row-placeholder:hover:not(:disabled) {
    background: white;
    border-color: var(--primary);
    color: var(--primary);
    transform: translateY(-1px);
}

.ft-sa-add-row-placeholder:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

/*
|--------------------------------------------------------------------------
| BADGE
|--------------------------------------------------------------------------
*/

.ft-sa-badge-um {
    font-size: 10px;
    background: #f1f5f9;
    color: #475569;
    padding: 2px 6px;
    border-radius: 4px;
    border: 1px solid #e2e8f0;
}

.ft-sa-badge-um-input {
    font-size: 10px;
    background: #f1f5f9;
    color: #475569;
    padding: 2px 6px;
    border-radius: 4px;
    border: 1px solid #0369a1 !important;
}

.sa-ft-input-custom {
    width: 100%;
    border: none;
    background: transparent;
    text-align: center;
    font-weight: 700;
    color: #475569;
}

/*
|--------------------------------------------------------------------------
| HELPERS
|--------------------------------------------------------------------------
*/

.text-center {
    text-align: center;
}

.text-right {
    text-align: right;
}
</style>